cartAnnouncementBar = (function () {
    const bar = document.querySelector('.custom-announcement');

    if (bar) {

        // Get value from cart 
        getCartValue = (cart) => {
            let cartQuantity = cart.items.length;

            if (cartQuantity == 0) {
                //document.querySelector('#fsb_container').style.display = "none";
                document.querySelector('.custom-announcement').style.display = "block";
                console.log("0 products");
            } else {
                document.querySelector('.custom-announcement').style.display = "none";
                //document.querySelector('#fsb_container').style.display = "block";
                console.log("have products");
            }
        }

        update = () => {
            fetch('/cart.js')
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(getCartValue)
                .catch(error => {
                    console.error('Error:', error);
                });
        }
    }
    return { update: update };
})();